import { Button, ButtonProps, Menu, MenuItem, PopoverOrigin } from '@mui/material';
import { useButtonMenu } from '@procureai/ui-mui';
import { ReactNode } from 'react';

type ButtonSelectItem = {
  label: string;
  value: any;
};

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export interface ButtonSelectProps extends ButtonProps {
  selected?: number | null;
  label?: ReactNode;
  items: ButtonSelectItem[];
  onItemClick: (index: number) => void;
}

export const ButtonSelect = ({ label, children, items, selected, onItemClick, ...otherProps }: ButtonSelectProps) => {
  const { menuProps, buttonProps } = useButtonMenu();
  return (
    <>
      <Button {...otherProps} {...buttonProps}>
        {selected !== undefined && selected !== null ? items[selected].label : label}
      </Button>
      <Menu {...menuProps} anchorOrigin={ANCHOR_ORIGIN} transformOrigin={TRANSFORM_ORIGIN}>
        {items.map((item, index) => (
          <MenuItem
            key={item.value}
            value={item.value}
            selected={index === selected}
            onClick={() => {
              onItemClick(index);
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
